import { Box, Typography } from '@mui/material'
import { toCustomUTCDateString } from '../../../components/common/time/timeHelper'
import '../../kyb/components/KybToPdf/components/daysLine.scss'
import { useTranslation } from 'react-i18next'

const RiskMatrixResultTitle = ({ riskResult, total }) => {
  const { t } = useTranslation(['common'])
  if (!riskResult?.date) {
    return <Typography>-</Typography>
  }

  if (riskResult?.riskScoreImpact) {
    const { riskScoreImpact, riskScoreProbability, riskScoreProbabilityRaw } = riskResult
    const date = toCustomUTCDateString(riskResult.date)
    return (
      <Typography fontWeight="bold">
        {`${date}  |  Impact result: ${riskScoreImpact} & Probability result: ${riskScoreProbability} (${riskScoreProbabilityRaw}) => Risk score: ${total}`}
      </Typography>
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
      <Typography variant="subtitle">{toCustomUTCDateString(riskResult.date)}</Typography> |
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
        {t('common:score')} {t('common:total')}
        <div className="trs-circle trs-md trs-item">
          <p className="trs-label">{total}</p>
        </div>
      </Box>
    </Box>
  )
}

export default RiskMatrixResultTitle
